module.exports = __webpack_public_path__ + "img/icon-money-wallet-open.847fd612.svg";